import React from 'react';
import { useLanguage } from '@/i18n/LanguageProvider';

export default function GoogleMapEmbed() {
  const { t } = useLanguage();
  const query = encodeURIComponent('Viale Regione Siciliana Nord Ovest 2132, 90135 Palermo');

  return (
    <section aria-labelledby="map-heading" className="border-t border-[#e5e5e5] pt-8">
      <h2 id="map-heading" className="mb-4 font-serif text-xl text-[#2d2d2d]">{t('Dove siamo')}</h2>
      <div className="aspect-[4/3] overflow-hidden bg-[#f0f0f0]">
        <iframe
          title="Mappa dello studio Bellomonte & Pensabene"
          src={`https://www.google.com/maps?q=${query}&output=embed`}
          className="h-full w-full border-0"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          allowFullScreen
        />
      </div>
    </section>
  );
}